<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-4">
          <b-row class="justify-content-center">
            <b-col xl="12" lg="12" md="12" class="px-5">
              <h1 class="text-white">Azure DevOps + Freshdesk Integrations</h1>
              <p class="text-primary font-weight-bold">
                Azure DevOps is an easy and quick integration between Freshdesk
                - DevOps. Create, Link, Notify, Search work items and fetch
                Reporting
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5 text-white">
      <b-row class="row mb-7">
        <b-col
          cols="12"
          style="cursor:pointer"
          onclick="document.location.href='https://www.freshworks.com/apps/freshdesk_azure_devops_integration//';"
        >
          <div class="status-card">
            <h2 class="ls-1 mb-2 text-mute text-center mb-0">
              How to connect Azure DevOps + Freshdesk
            </h2>
            <h3 class="ls-1 text-white mb-0">
              Integration App lets you send info between Azure DevOps and
              Freshdesk automatically—no code required.
            </h3>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <div class="about-content">
            <h2 class="ls-1 text-info">
              Connect your apps and automate workflows
            </h2>
            <!-- <h3 class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0">Zendesk - Azure DevOps Integration</h3> -->
            <p>
              Easy automation for busy people. ADO Integration moves info
              between your web apps automatically, so you can focus on your most
              important work.
            </p>
            <p>
              Azure DevOps integrates your work items. Create bugs, features, or
              custom work items. Use area paths, iteration, priority, severity.
              Azure DevOps integrates your work items and your own custom
              fields. link existing bugs, features, or custom work items. Notify
              workitems. Azure DevOps integration allows you to sync your
              comments, status, system fields and custom fields in both
              directions based on your needs.
            </p>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="about-img about-img-before">
            <img
              src="assets/img/apps/freshdesk/App.png"
              alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
              style="max-width:100%;"
              class="pt-5"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <div class="about-img about-img-before">
            <img
              src="assets/img/apps/freshdesk/CreateWorkItem.png"
              alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Zendesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
              style="max-width:100%;"
              class="pt-5"
            />
          </div>
        </b-col>
        <b-col cols="6">
          <div class="about-content">
            <h2 class="ls-1 text-info mt-5">About Azure DevOps</h2>
            <p>
              Azure DevOps is where teams manage, develop, and deliver software
              in the cloud. Azure DevOps provides free, private Git project
              hosting for up to 5 users, project and test management tools,
              build and CI, and team collaboration. Connect using the
              development tools of your choice, including Visual Studio,
              Eclipse, Xcode, and more.
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <div class="about-content">
            <h2 class="ls-1 text-info mt-5">About Freshdesk</h2>
            <!-- <h3 class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0">Zendesk - Azure DevOps Integration</h3> -->
            <p>
              Freshdesk is an online cloud-based customer support software
              providing help desk support with all smart automations to get
              things done faster. It has remained a popular choice for
              businesses that want to increase customer engagement and manage
              customers as they scale.
            </p>
            <p>
              Freshdesk supports pretty useful features for customer engagement,
              like:
            </p>
            <ol>
              <li>Omnichannel help desk</li>
              <li>Team collaboration</li>
              <li>Artificial intelligence (AI) and chatbot capabilities</li>
              <li>Multi-channel communication management</li>
              <li>
                Self-service support portal for support agents and customers
              </li>
            </ol>
          </div>
        </b-col>
        <b-col cols="6">
          <div id="video">
            <iframe
              width="560"
              height="315"
              title="Freshdesk Azure DevOps Integration Pro"
              src="https://www.youtube.com/embed/RSUYmGGAjlY?autoplay=1&mute=1&autohide=0&controls=0&modestbranding=1&rel=0&showinfo=0&disablekb=1&loop=1"
              frameborder="0"
              scrolling="no"
              allowfullscreen
            ></iframe>
          </div>
        </b-col>
      </b-row>
      <!--old code-->
      <b-row class="row">
        <b-col
          cols="12"
          style="cursor:pointer"
          onclick="document.location.href='https://www.freshworks.com/apps/freshdesk_azure_devops_integration//';"
        >
          <div class="status-card">
            <h3 class="ls-1 text-primary mb-0">Freshdesk Azure DevOps</h3>
            <div>
              Azure DevOps integrates your work items. Create bugs, features, or
              custom work items. Use area paths, iteration, priority, severity.
              Azure DevOps integrates your work items and your own custom
              fields. link existing bugs, features, or custom work items. Notify
              workitems. Azure DevOps integration allows you to sync your
              comments, status, system fields and custom fields in both
              directions based on your needs.
              <!-- <img src="https://lh3.googleusercontent.com/1NGc49-tt6eFHSUh8RiWLy4XzrNy4qkX7PZFwAJYhcu6Xc2GQUuyMdq64VhR5eWsflftc2i0_-bXm6QaP7NaN0neP9bndShGMUclEBoD8vxxIXDonJaq5J0U_rqzamvC4ef7ilnqj3-knU4R1wS9zeRZzUhKDs3824sw05rmzGgUtQPRszOq5m5W0VhgjNZmiWfkQ14DBcBl12qM1VuTgU70I4Lj1FpH3ODq6WYGyumdw2s-93xaKEJXy7VRcXWbbFt4kBUbDoIh7JQWc9S7hqvbM1Prd11FjppebuUZq_7VV7PfHx1wO-x_vSG5-MytE9vTQvrXTB7dr8CVawBrRuJ0YZKUS3mQcWr3BI1wS79fS5_S4cp-fze5k3lJj_aq-ycYPTRJd4__H3YGg3z9Nw58pZ72qb_0hwwUMPQvluZAbnnktt_c-j2_YinBh8q_4N4etWyikO9OpzGUOEn1Didj2x_90xMZ5VJPsPsAKnKjts6QSrQWasrSuYfTYIXfh3Hl9CALCKmEss8b1wBdAwKN-g4t0uEzM_KkCKIXNFH7qREmJAId8Lw9vnWpLoU_0525jY-bhSQP0289WyOFdlI5MjNEi7LcT-tDEy64_Jh6EDWnlaO0LnW8xvsn87Wb4JXhDEjTFmZwwqARNh14JyCcAw42XqyFh4wr83dimzmgxhqFcPPnVfkhxxgfj74dc6TNAAbFrtomRKW_-VouJmk=w1024-h507-no"
                            alt="Freshdesk Azure DevOps Integration Pro" title="Freshdesk Azure DevOps Integration Pro"> -->
              <div id="video">
                <iframe
                  width="560"
                  height="315"
                  title="Freshdesk Azure DevOps Integration Pro"
                  src="https://www.youtube.com/embed/RSUYmGGAjlY?autoplay=1&mute=1&autohide=0&controls=0&modestbranding=1&rel=0&showinfo=0&disablekb=1&loop=1"
                  frameborder="0"
                  scrolling="no"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="row">
        <b-col
          cols="12"
          style="cursor:pointer"
          onclick="document.location.href='https://www.freshworks.com/apps/freshdesk_azure_devops_integration//';"
        >
          <div class="status-card">
            <h3 class="ls-1 text-primary mb-0">
              How to connect Azure DevOps + Freshdesk
            </h3>
            <div>
              Azure DevOps integrates your work items. Create bugs, features, or
              custom work items. Use area paths, iteration, priority, severity.
              Azure DevOps integrates your work items and your own custom
              fields. link existing bugs, features, or custom work items. Notify
              workitems. Azure DevOps integration allows you to sync your
              comments, status, system fields and custom fields in both
              directions based on your needs.
              <!-- <img src="https://lh3.googleusercontent.com/1NGc49-tt6eFHSUh8RiWLy4XzrNy4qkX7PZFwAJYhcu6Xc2GQUuyMdq64VhR5eWsflftc2i0_-bXm6QaP7NaN0neP9bndShGMUclEBoD8vxxIXDonJaq5J0U_rqzamvC4ef7ilnqj3-knU4R1wS9zeRZzUhKDs3824sw05rmzGgUtQPRszOq5m5W0VhgjNZmiWfkQ14DBcBl12qM1VuTgU70I4Lj1FpH3ODq6WYGyumdw2s-93xaKEJXy7VRcXWbbFt4kBUbDoIh7JQWc9S7hqvbM1Prd11FjppebuUZq_7VV7PfHx1wO-x_vSG5-MytE9vTQvrXTB7dr8CVawBrRuJ0YZKUS3mQcWr3BI1wS79fS5_S4cp-fze5k3lJj_aq-ycYPTRJd4__H3YGg3z9Nw58pZ72qb_0hwwUMPQvluZAbnnktt_c-j2_YinBh8q_4N4etWyikO9OpzGUOEn1Didj2x_90xMZ5VJPsPsAKnKjts6QSrQWasrSuYfTYIXfh3Hl9CALCKmEss8b1wBdAwKN-g4t0uEzM_KkCKIXNFH7qREmJAId8Lw9vnWpLoU_0525jY-bhSQP0289WyOFdlI5MjNEi7LcT-tDEy64_Jh6EDWnlaO0LnW8xvsn87Wb4JXhDEjTFmZwwqARNh14JyCcAw42XqyFh4wr83dimzmgxhqFcPPnVfkhxxgfj74dc6TNAAbFrtomRKW_-VouJmk=w1024-h507-no"
                            alt="Freshdesk Azure DevOps Integration Pro" title="Freshdesk Azure DevOps Integration Pro"> -->
              <div id="video">
                <iframe
                  width="560"
                  height="315"
                  title="Freshdesk Azure DevOps Integration Pro"
                  src="https://www.youtube.com/embed/RSUYmGGAjlY?autoplay=1&mute=1&autohide=0&controls=0&modestbranding=1&rel=0&showinfo=0&disablekb=1&loop=1"
                  frameborder="0"
                  scrolling="no"
                  allowfullscreen
                ></iframe>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <div class="text-center" style="margin-top:30px;margin-bottom:30px;">
            <a
              href="https://www.freshworks.com/apps/freshdesk_azure_devops_integration/"
              target="_blank"
              class="btn btn-primary"
              >Click to Install the app</a
            >
            <!-- <router-link to="/contact" class="btn btn-primary text-center book-btn">Request A Demo</router-link> -->
            <a
              href="mailto:support@devopsintegration.io"
              target="_blank"
              class="btn btn-primary text-center book-btn"
              >Write to Us</a
            >
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <div class="about-content">
            <h3
              class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
            >
              Freshdesk - Azure DevOps Integration
            </h3>
            <p>
              Freshdesk-Azure DevOps Integration App simple integration between
              Freshdesk and Azure DevOps. Support agents using this app can
              Create, link, notify Azure DevOps work items. You can Collaborate
              your support team and developers at one place. Freshdesk-Azure
              DevOps app allows the support agents to create Azure DevOps work
              items from Freshdesk apps form. Freshdesk-Azure DevOps app also
              allows support agents to link existing Freshdesk tickets to an
              existing Azure DevOps work items. In addition, Freshdesk-Azure
              DevOps app allows support agents to help notify the Azure DevOps
              team, by sending comments from Freshdesk support.
            </p>
            <p>
              We also support customization based on customer request and
              tailored to your needs! We bring Azure DevOps closer to your
              business requirements!
            </p>
          </div>
        </b-col>
        <b-col cols="6">
          <div class="about-img about-img-before">
            <img
              src="assets/img/apps/freshdesk/App.png"
              alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
              style="max-width:100%;"
              class="pt-5"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col col="12" class="mb-3 mt-3 bg-gradient-primary">
          <h1 class="text-uppercase text-center text-white font-weight-bold">
            Freshdesk - Azure DevOps Integration App Features and Usage
          </h1>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <img
            src="assets/img/apps/freshdesk/CreateWorkItem.png"
            class="apps-img"
            alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
            style="max-width:100%;"
          />
        </b-col>
        <b-col cols="6">
          <h3
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            Create Work Item:
          </h3>
          <p>
            The Create Work Item: lets the user to create new work item # in
            Azure DevOps from Freshdesk, support agent can select type of work
            item he/she want to create like Bug, Epic, Feature, Task, User Story
            etc. Based on the work item type selection he will see all the Azure
            DevOps fields. The User can make the selection and click on Create
            button which would create work item in Azure DevOps and then display
            the corresponding Azure DevOps work item Id in the App.
          </p>
          <p>
            The Freshdesk-Azure DevOps app provides couple of options like
            Create Work Item, Link Work Item, Notify Linked Work Items, Work
            Item History, Enable Syncing & Configure App.
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <h3
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            Link Work Item:
          </h3>
          <p>
            Using this button in Freshdesk-DevOps app support agent can link an
            existing Azure DevOps Workitem # to current Freshdesk ticket.
            Freshdesk-Azure DevOps app allows the user to create or link
            multiple work items to one Freshdesk ticket.
          </p>
          <p>
            Freshdesk Agent can enter either the full Azure DevOps Work Item URL
            or just the Work Item # (e.g. 123) to link to existing Freshdesk
            ticket. Once the Azure DevOps Work Item is linked, it will start
            displaying the work item information in the App area.
          </p>
        </b-col>
        <b-col cols="6">
          <img
            src="assets/img/apps/freshdesk/LinkWorkItem.png"
            class="apps-img"
            alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <img
            src="assets/img/apps/freshdesk/Notify.png"
            class="apps-img"
            alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
          />
        </b-col>
        <b-col cols="6">
          <h3
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            Notify:
          </h3>
          <p>
            Notify button in Freshdesk-Azure DevOps app allows the support agent
            to notify all the linked Azure DevOps work items to current
            Freshdesk ticket these will show up as comments in Azure DevOps.
          </p>
          <p>
            The Freshdesk Agent can also upload new files from his/her local
            computer or select the attachments which are already uploaded to the
            Freshdesk ticket comments. These will be uploaded to the Azure
            DevOps Work Item in the Links/Attachments section.
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <h3
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            Work Item History:
          </h3>
          <p>
            In the Freshdesk-Azure DevOps app Work Item History modal shows you
            couple of details of work item history including the comments
            history to current Freshdesk ticket.
          </p>
          <p>
            The Freshdesk Agent can also use this screen to send the
            comments,attachments to the corresponding Azure DevOps Work Item.
            This Work Item History is current/live history of Azure DevOps Work
            Item since we are not storing any kind of information on our server.
          </p>
        </b-col>
        <b-col cols="6">
          <img
            src="assets/img/apps/freshdesk/WorkItemLog.png"
            class="apps-img"
            alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <img
            src="assets/img/apps/freshdesk/SearchWorkItem.png"
            class="apps-img"
            alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
          />
        </b-col>
        <b-col cols="6">
          <h3
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            Search Work Item:
          </h3>
          <p>
            In the Freshdesk-Azure DevOps app Search Work Item modal shows you
            to search the work items by number of options. Freshdesk Agent can
            search the work items by Project, Work Item Type, Title,
            Description, Area, Iteration or even using a work item #.
          </p>
          <p>
            Freshdesk Agent can link or directly send the message to the
            selected work items in the Grid. Freshdesk Agent can also upload the
            files and send to the selected Work Items.
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <h3
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            Reporting:
          </h3>
          <p>
            In the Freshdesk-Azure DevOps app Linked history log modal shows you
            the details linked tickets between Freshdesk and Azure DevOps.You
            can also export the CSV details of linked tickets.
          </p>
          <p>
            You can filter, sort and see the history of work items. This history
            will the current history of all the work items
          </p>
        </b-col>
        <b-col cols="6">
          <img
            src="assets/img/apps/freshdesk/Reporting.png"
            class="apps-img"
            alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <img
            src="assets/img/apps/freshdesk/Customize.png"
            class="apps-img"
            alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
          />
        </b-col>
        <b-col cols="6">
          <h3
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            Customize View:
          </h3>
          <p>
            In the Freshdesk-Azure DevOps app Customize view modal allows you to
            customize the view of Create work item screen. You can hide the
            Areas, Iterations, Custom Fields etc. You can also disable the files
            upload functionality if its not required by your company.
          </p>
          <p>
            This view also allows you to configure the status mappings between
            Freshdesk and Azure DevOps. so e.g. If ADO work item is Closed or
            Done you want to sync that status back to Freshdesk. or if you want
            to change the Freshdesk Status to Resolved or something.
          </p>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <h4
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            Configure App:
          </h4>
          <p>
            In the Freshdesk-Azure DevOps app Configure App lets you enable the
            syncing of few fields from Freshdesk to Azure DevOps and Azure
            DevOps to Freshdesk.
          </p>
          <p>
            Configure app screen allows you to auto fill the Custom Field ids in
            both Freshdesk and Azure DevOps with Freshdesk Ticket # and Azure
            DevOps Work Item #.
          </p>
        </b-col>
        <b-col cols="6">
          <img
            src="assets/img/apps/freshdesk/Configure.png"
            class="apps-img"
            alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <h3
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            Enable Syncing:
          </h3>
          <p>
            In the Freshdesk-Azure DevOps app Enable Syncing lets you enable the
            syncing of data from Freshdesk to Azure DevOps and Azure DevOps to
            Freshdesk.
          </p>
          <h5
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            We are providing the few types of syncing of comments from Azure
            DevOps to Freshdesk:-
          </h5>
          <ol>
            <li>Syncing of all comments from Azure DevOps to (Freshdesk).</li>
            <li>
              Syncing of tag based comments from Azure DevOps to (Freshdesk).
            </li>
            <li>
              Posting comment to Freshdesk as Public or Private tag based.
            </li>
          </ol>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <div class="text-center" style="margin-top:30px;margin-bottom:30px;">
            <a
              href="https://www.freshworks.com/apps/freshdesk_azure_devops_integration/"
              target="_blank"
              class="btn btn-primary"
              >Click to Install the app</a
            >
            <router-link
              to="/contact"
              class="btn btn-primary text-center book-btn"
              >Request A Demo
            </router-link>
            <a
              href="mailto:support@devopsintegration.io"
              target="_blank"
              class="btn btn-primary text-center book-btn"
              >Write to Us</a
            >
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="6">
          <h4
            class="text-uppercase ls-1 py-3 mb-0 text-primary font-weight-bold mb-0"
          >
            Installation and Authentication:
          </h4>
          <ol>
            <li>
              <p>
                Click Install button to install the app to your Freshdesk
                instance.
              </p>
            </li>
            <li>
              <p>
                Once the app is installed, go to any of your existing ticket or
                create a new ticket.
              </p>
            </li>
            <li>
              <p>
                Click on the Apps link and you will see the DevOps Integration
                Azure DevOps App.
              </p>
            </li>
            <li>
              <p>
                Click on Authenticate button to authenticate your Freshdesk and
                Azure DevOps Credentials. In the popup fill the Freshdesk URL,
                Freshdesk API token and Azure DevOps credentials like Azure
                DevOps account URL, Azure DevOps personal access token then
                click validate. Once the credentials are validated you are ready
                to use the app.
              </p>

              <ol>
                <li>
                  Now you will see the app to start displaying buttons like
                  Create, Link etc buttons in your app.<br />
                </li>
              </ol>
            </li>
            <li>
              <p>
                Now you can Create new Azure DevOps work item from Freshdesk -
                Azure DevOps app or link existing work item to your current
                Freshdesk ticket #.
              </p>
            </li>
          </ol>
        </b-col>
        <b-col cols="6">
          <img
            src="assets/img/apps/freshdesk/Authentication.png"
            class="apps-img"
            alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
          />
          <img
            src="assets/img/apps/freshdesk/App.png"
            class="apps-img"
            alt="Freshdesk Azure Devops Connector, Freshdesk Azure Devops Connector, Freshservice Azure Devops Connector, Freshdesk - Azure DevOps Integration, Freshdesk - Azure DevOps Integration, Freshservice - Azure DevOps Integration"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <div class="text-center" style="margin-top:30px;margin-bottom:30px;">
            <a
              href="https://www.freshworks.com/apps/freshdesk_azure_devops_integration/"
              target="_blank"
              class="btn btn-primary"
              >Click to Install the app</a
            >
            <router-link
              to="/contact"
              class="btn btn-primary text-center book-btn"
              >Request A Demo
            </router-link>
            <a
              href="mailto:support@devopsintegration.io"
              target="_blank"
              class="btn btn-primary text-center book-btn"
              >Write to Us</a
            >
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6"> </b-col>
        <b-col cols="6"> </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import PricingQuote from "@/components/pricing-quote/pricing-quote.vue";
export default {
  components: { PricingQuote }
};
</script>
<style scoped>
img {
  max-width: 100%;
}
</style>
